export default __webpack_public_path__ + "media/images/business/follow_logo-5944aff35b4a4926e1440826f0433fea.png";